import React from "react";
import PropTypes from "prop-types";

const IndividualsAndGroupsIllustration = props => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 292 292"
      fill={props.fill}
      style={props.style}
    >
      <rect width={props.width} height={props.height} fill="#F8FCED" />
      <g clipPath="url(#clip0_8331_202282)">
        <path
          d="M31.6118 213.605L38.7436 171.104L96.2134 166.463C97.7087 171.899 100.831 184.257 101.357 190.208C101.884 196.159 106.891 209.576 109.329 215.541L31.6118 213.605Z"
          fill="#FFBB33"
        />
        <path
          d="M86.5101 92.617C84.0349 88.5398 79.1812 85.9065 77.0638 85.0995L73.776 87.1011C69.9033 91.1541 71.0521 101.907 74.5849 105.465C77.411 108.311 79.1695 112.465 79.6954 114.186C88.7388 108.724 89.6042 97.7135 86.5101 92.617Z"
          fill="#483000"
        />
        <path
          d="M74.1856 82.2922C74.1856 82.2922 76.8226 81.2523 77.7941 83.3197C78.7657 85.3871 76.2902 87.7929 74.5202 88.6247C72.7503 89.4565 70.78 86.3776 71.1277 85.4132C71.4755 84.4488 73.1537 82.528 74.1856 82.2922Z"
          fill="#F76E88"
        />
        <path
          d="M15.7508 158.7C14.6055 163.241 17.2379 167.093 18.6972 168.452L26.2586 168.745L42.1497 144.776L38.417 172.229L106.504 171.164C117.603 168.277 110.582 146.641 104.885 130.354C99.1879 114.067 91.9088 107.257 88.0213 103.541C84.9112 100.568 78.9282 99.0811 73.0126 97.9765L58.5099 98.3133C54.3832 98.7505 42.0432 103.235 38.0497 108.056C33.0579 114.081 29.2358 124.21 25.1064 133.65C20.977 143.089 17.1824 153.024 15.7508 158.7Z"
          fill="#D4F197"
        />
        <path
          d="M42.3624 72.2034C43.6502 79.979 50.8496 84.7708 54.2883 86.1948C59.2772 87.0441 70.8818 87.3543 77.3891 81.8011C85.5234 74.8596 84.5438 52.6213 79.106 47.9657C73.6681 43.31 59.5735 41.3988 51.7762 48.3255C43.9789 55.2522 40.7527 62.4839 42.3624 72.2034Z"
          fill="#483000"
        />
        <path
          d="M55.5279 99.1382C56.3288 95.862 54.4674 83.5087 53.4536 78.3768L73.8448 93.4362C72.8971 96.4488 73.1753 101.23 73.4328 103.245C76.2192 108.254 74.7966 109.937 73.737 110.152C69.208 111.567 58.1018 103.92 55.5279 99.1382Z"
          fill="#D1905E"
        />
        <path
          d="M73.1905 97.2552L73.5698 94.3689L53.6737 79.5469L55.063 88.0945C59.8737 97.673 68.9512 100.649 73.1905 97.2552Z"
          fill="#B6773D"
        />
        <path
          d="M62.4614 193.136C59.2873 196.324 49.8694 201.128 46.7782 203.204C48.5383 202.701 52.3432 203.204 57.073 200.482C58.0814 199.901 63.7898 195.783 66.0173 193.136C67.7993 191.019 73.0817 185.504 75.5002 183.011C73.0076 184.814 65.6355 189.948 62.4614 193.136Z"
          fill="#C28200"
        />
        <path
          d="M85.7268 78.1713C85.413 73.9813 85.8934 67.5889 86.1728 64.9164C86.0099 60.0158 83.2021 56.645 81.8186 55.5722C79.9666 53.4395 74.5343 49.4729 67.6216 50.6684C60.709 51.8638 55.0494 59.1177 53.0837 62.5952C53 67.0593 53.0613 77.1117 53.9759 81.6085C55.1191 87.2296 59.9056 90.1669 62.6055 91.9248C65.3055 93.6827 71.7024 97.026 77.4422 92.6106C83.1819 88.1952 86.1192 83.4087 85.7268 78.1713Z"
          fill="#D1905E"
        />
        <path
          d="M77.9286 55.7821C79.7241 59.7542 84.0772 65.0766 86.0294 67.2413C87.9746 61.5852 84.41 53.471 82.4455 51.0255C80.481 48.5801 71.7085 41.0329 57.6332 47.2233C46.373 52.1756 45.9274 63.7749 47.1121 68.9555L53.1994 69.1938C63.946 67.9102 74.1633 59.7178 77.9286 55.7821Z"
          fill="#483000"
        />
        <path
          d="M77.3939 161.89C79.5804 164.157 80.1769 168.958 80.2607 171.206L50.2604 171.206C48.5555 169.709 52.7608 168.814 53.5935 167.961C54.4263 167.107 61.4256 160.275 63.9591 160.581C66.4926 160.888 70.9079 163.363 71.5824 163.355C72.122 163.348 75.7721 162.585 77.3939 161.89Z"
          fill="#D1905E"
        />
        <path
          d="M54.1218 167.986L59.9942 167.04M57.0657 165.025L59.9611 164.342"
          stroke="#B6773D"
          strokeWidth="0.674546"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M89.3661 156.49C86.8934 158.422 82.4677 160.527 77.5614 162.055C81.8589 161.583 84.5492 160.332 86.6678 159.526C92.4016 157.345 94.3453 153.04 97.0409 153.158C99.1973 153.253 102.543 155.989 103.946 157.345C103.585 156.598 102.737 154.895 102.234 154.062C101.73 153.23 98.1524 152.195 96.4264 151.781C97.9525 151.623 101.274 151.319 102.353 151.367C103.431 151.414 105.775 152.868 106.812 153.589C106.4 152.727 105.079 150.778 103.093 149.88C101.107 148.982 97.5742 150.259 96.1116 150.251C96.2155 147.892 94.7402 142.83 93.7507 131.701C93.3682 127.399 90.2323 115.054 89.1982 112.982C89.3347 117.546 92.9075 134.632 92.9075 137.266C92.9075 144.348 93.1581 147.336 94.4252 151.781C93.8337 152.675 94.7625 152.275 89.3661 156.49Z"
          fill="#BDE26C"
        />
        <path
          d="M48.5761 67.6405C51.3649 66.5724 53.6558 69.2749 54.6285 70.9201C55.0933 72.5314 55.8094 76.2699 54.955 78.3331C53.887 80.9122 50.1658 79.1017 49.1825 77.5746C47.9141 75.6049 45.0901 68.9756 48.5761 67.6405Z"
          fill="#D1905E"
        />
        <path
          d="M37.4384 92.093C39.5456 87.814 44.1489 84.7641 46.1872 83.774L49.6383 85.4788C53.8523 89.1756 53.6534 99.9876 50.4471 103.842C47.8822 106.926 46.4958 111.219 46.1232 112.979C36.6346 108.333 34.8044 97.4418 37.4384 92.093Z"
          fill="#483000"
        />
        <path
          d="M48.8039 80.7279C48.8039 80.7279 46.0858 79.9238 45.2997 82.0686C44.5137 84.2134 47.1912 86.3923 49.0274 87.0652C50.8637 87.7382 52.5556 84.4979 52.1244 83.5678C51.6932 82.6377 49.8526 80.872 48.8039 80.7279Z"
          fill="#F76E88"
        />
        <path
          d="M24.0415 146.568C21.8064 149.616 19.0086 154.483 17.8891 156.536L39.6389 136.667L39.7061 133.969C35.8035 134.884 26.8355 142.758 24.0415 146.568Z"
          fill="#BDE26C"
        />
        <path
          d="M49.8502 113.863L47.7096 116.894L67.9418 131.186L70.0824 128.156L49.8502 113.863Z"
          fill="#F76E88"
        />
        <path
          d="M45.9782 113.402C46.2621 113 46.7205 112.746 47.2526 112.696C47.7847 112.646 48.3469 112.804 48.8155 113.135L49.8499 113.866L47.7093 116.896L46.6749 116.165C46.2063 115.834 45.8696 115.357 45.739 114.839C45.6083 114.321 45.6944 113.804 45.9782 113.402Z"
          fill="#6464DC"
        />
        <path
          d="M49.8502 113.863L47.7096 116.894L48.3321 117.333L50.4727 114.303L49.8502 113.863Z"
          fill="white"
        />
        <path
          d="M67.9407 131.188L71.5984 131.294L70.0813 128.158L67.9407 131.188Z"
          fill="#FFDF99"
        />
        <path
          d="M71.1143 130.33L69.7717 131.24L71.6006 131.293L71.1143 130.33Z"
          fill="#282796"
        />
        <path
          d="M39.6414 129.75C38.765 132.427 36.4557 135.743 35.4106 137.067L39.7812 137.682C40.4455 135.843 41.8163 131.828 41.9848 130.483C42.1533 129.138 42.8214 121.732 43.1344 118.197C42.3352 120.933 40.5178 127.073 39.6414 129.75Z"
          fill="#BDE26C"
        />
        <path
          d="M46.2226 129.742C45.5214 130.805 44.079 132.276 43.4454 132.878L36.8318 137.941L48.2991 143.506C48.8385 142.17 52.09 137.986 55.6428 137.568C56.8561 137.426 59.2545 134.79 60.3038 133.298C60.5708 133.867 60.808 134.728 61.6273 134.344C62.6514 133.863 64.0883 130.356 63.7763 129.337C63.4644 128.317 62.2459 123.057 60.8972 123.023L56.514 122.914C57.2024 122.369 58.6057 121.265 59.0919 121.246C60.271 121.201 62.4646 123.27 63.4764 121.063C62.3327 119.573 58.4927 118.511 57.2368 118.717C55.3088 119.034 52.1985 121.432 51.5032 122.258C50.8079 123.084 47.0991 128.415 46.2226 129.742Z"
          fill="#D1905E"
        />
        <path
          d="M17.1353 157.441C14.2668 161.472 15.396 169.173 16.2154 171.01L31.2096 171.67C35.7584 171.871 41.1971 158.658 43.2136 155.033C47.6564 147.047 50.5865 143.437 50.153 141.685C44.4193 139.292 44.2369 133.832 42.614 132.354C39.6299 135.484 33.3616 139.615 31.2096 141.685C24.4693 148.166 24.3442 147.31 17.1353 157.441Z"
          fill="#D4F197"
        />
        <path
          d="M44.8765 149.952C42.7426 154.352 40.6529 159.237 39.8747 161.129L39.2219 167.017C40.3457 164.796 43.7291 158.088 44.7505 155.009C46.0272 151.161 47.2172 149.041 48.4687 146.205C49.4699 143.936 49.8641 141.882 49.6491 141.483C49.6113 143 47.5439 144.452 44.8765 149.952Z"
          fill="#BDE26C"
        />
        <path
          d="M52.7252 75.9041C52.0506 72.3965 50.5329 70.7326 49.8583 70.3391C50.6678 71.4184 51.2074 73.2621 51.3761 74.0491L49.8583 74.555C50.6678 74.8248 52.1068 75.5668 52.7252 75.9041Z"
          fill="#B6773D"
        />
        <path
          d="M60.2717 133.219L60.9462 131.027M59.0912 128.666C60.2717 128.329 61.4521 127.992 62.9699 127.992M58.248 125.462C59.2037 125.237 60.7776 125.125 62.1267 125.125"
          stroke="#B6773D"
          strokeWidth="0.674546"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M127.158 149.989C127.158 149.989 124.737 159.418 118.834 158.994C115.733 158.781 105.115 147.314 105.115 147.314L127.158 149.989Z"
          fill="#EEAF7C"
        />
        <path
          d="M171.542 99.1923C171.542 99.1923 182.5 105.733 185.558 108.154C188.616 110.575 191.079 120.556 191.716 124.888C192.354 129.22 193.967 154.534 193.967 154.534C193.967 154.534 191.759 146.167 186.875 144.171C186.875 144.171 183.349 162.222 182.755 165.11C182.16 167.955 184.411 182.396 184.411 182.396L123.93 179.381C123.93 179.381 126.648 157.677 125.162 144.808C124.78 141.622 126.988 132.151 126.988 132.151L118.154 120.131C118.154 120.131 127.286 104.544 130.726 102.505C134.166 100.466 146.101 98.8525 146.101 98.8525L171.542 99.1923Z"
          fill="#D4F197"
        />
        <path
          d="M167.463 88.7034C167.463 88.7034 167.081 94.5221 171.54 99.1516C171.54 99.1516 165.254 105.353 154.636 106.712C144.018 108.071 142.829 104.97 143.126 103.993C143.424 103.017 146.397 101.105 146.099 98.8543C145.76 96.6457 167.463 88.7034 167.463 88.7034Z"
          fill="#EEAF7C"
        />
        <path
          d="M169.205 88.1921C169.205 88.1921 170.522 89.5513 167.379 93.2464C165.807 95.0727 163.854 96.3044 160.074 98.7253C156.888 100.722 145.293 104.799 144.911 101.826L144.104 97.4087L163.429 88.7443L169.205 88.1921Z"
          fill="#D1905E"
        />
        <path
          d="M134.037 62.7099C134.037 62.7099 132.466 72.606 132.976 74.8146C133.485 77.0231 133.23 78.3823 133.018 79.1892C132.806 79.9537 133.698 88.9155 136.034 93.4176C138.327 97.9196 140.026 100.298 143.424 100.85C149.625 101.87 157.78 94.9891 158.332 94.0122C158.884 93.0353 162.961 86.3246 162.494 82.1199C161.984 77.9575 156.336 61.3083 151.111 59.9916C145.887 58.675 136.246 57.5707 134.037 62.7099Z"
          fill="#EEAF7C"
        />
        <path
          d="M163.896 82.5861C163.896 82.5861 162.622 84.0302 162.495 83.8178C162.367 83.6055 159.734 77.9991 158.545 77.9141C157.356 77.8292 157.441 77.1072 157.143 75.6631C156.846 74.2615 157.058 73.8792 156.464 74.1765C155.869 74.4739 155.997 75.5357 155.572 74.0916C155.105 72.6051 155.572 73.3696 154.383 71.5857C153.193 69.8019 150.645 68.7401 150.475 68.1454C150.305 67.5508 152.174 64.8751 150.178 64.4079C148.182 63.9407 149.116 65.9793 147.842 65.767C146.568 65.5546 144.614 67.2535 144.402 66.6589C144.189 66.0643 144.232 64.8751 142.703 65.2573C141.174 65.6396 141.131 66.9562 140.621 66.7438C140.112 66.5315 137.946 68.5277 137.181 67.4234C136.417 66.3191 135.61 68.018 134.803 67.6358C133.996 67.2535 132.467 66.4465 132.339 65.3847C132.212 64.3229 129.494 64.0256 129.579 63.1337C129.664 62.2418 128.007 61.1799 128.814 59.9058C129.621 58.6316 134.208 53.6198 134.59 52.9403C134.973 52.2607 134.505 50.7742 135.652 49.9672C136.756 49.1602 138.285 50.5618 139.39 48.9903C140.494 47.4188 140.961 46.9516 141.853 46.7393C142.745 46.5269 144.784 45.8473 145.761 44.9554C146.738 44.0635 148.734 44.1909 149.583 44.0635C150.433 43.9361 152.854 43.0866 154.298 43.0017C155.742 42.9167 156.549 45.6774 158.333 45.6774C160.116 45.6774 160.966 43.8936 162.155 43.8936C163.344 43.8936 163.854 42.7044 165.086 43.4264C166.275 44.1909 168.823 43.3415 168.144 44.6156C167.464 45.8898 167.931 46.6968 170.225 46.4844C172.518 46.2721 170.607 50.3919 171.329 50.5193C172.051 50.6467 178.422 50.9865 178.507 52.0059C178.592 53.0252 176.044 49.3726 176.341 51.836C176.638 54.2994 176.171 54.809 177.105 55.6585C178.04 56.508 180.036 57.9945 180.078 60.5853C180.163 63.2186 177.912 63.2611 178.38 65.4272C178.847 67.5933 180.928 63.0487 180.121 66.1917C179.314 69.3347 178.38 68.825 178.465 70.2266C178.549 71.6282 181.82 69.4621 180.843 72.1803C179.866 74.8986 180.078 78.2539 179.866 79.8254C179.654 81.3969 179.951 79.3582 178.592 81.9066C177.233 84.4549 176.511 81.3969 175.959 83.0958C175.406 84.7947 176.638 85.6441 175.449 86.621C174.26 87.5979 174.854 86.1538 172.773 88.3199C170.692 90.486 171.499 89.2118 168.738 90.7833C165.978 92.3548 163.472 93.1193 163.599 92.2699C163.727 91.4629 162.877 89.4242 163.599 88.0651C164.194 86.8334 163.896 82.5861 163.896 82.5861Z"
          fill="#785100"
        />
        <path
          d="M110.804 125.653C110.804 125.653 95.0042 111.722 78.4399 113.294C78.4399 113.294 79.2044 116.224 76.5286 117.668L114.839 133.213L135.013 112.657C135.013 112.699 117.472 120.387 110.804 125.653Z"
          fill="#FFCC66"
        />
        <path
          d="M162.452 83.8168C162.452 83.8168 165.085 79.8669 166.444 79.612C167.803 79.3572 169.8 81.9905 168.271 85.3883C166.742 88.7436 164.533 90.4425 163.853 92.0565C163.174 93.6705 159.521 94.2226 159.139 92.5237C158.757 90.8248 162.452 83.8168 162.452 83.8168Z"
          fill="#EEAF7C"
        />
        <path
          d="M176.638 135.167C176.638 135.167 176.595 132.109 176.128 129.476C175.661 126.843 176.128 117.881 176.128 117.881C176.128 117.881 174.684 124.125 174.429 126.503C174.174 128.882 175.534 135.125 175.534 135.125H176.638V135.167Z"
          fill="#BDE26C"
        />
        <path
          d="M153.787 118.39L145.335 107.73C145.335 107.73 121.847 118.22 110.422 128.032C110.422 128.032 89.2285 115.29 75.0002 117.923L106.005 150.627C106.005 150.627 123.122 155.426 127.624 159.334C127.624 159.334 155.868 139.287 167.803 139.966L153.787 118.39Z"
          fill="#FFBB33"
        />
        <path
          d="M193.925 151.053C193.925 151.053 192.311 144.852 186.535 143.535L170.098 127.778C170.098 127.778 166.403 117.16 164.704 116.863C163.005 116.565 153.618 118.222 152.344 118.731C151.07 119.241 151.622 120.388 152.344 120.643C152.344 120.643 148.012 121.195 149.498 123.149C149.498 123.149 145.846 124.295 148.564 126.079C148.564 126.079 146.398 127.821 150.943 129.052C155.445 130.284 158.757 129.732 160.117 131.091C161.476 132.45 163.387 133.894 163.387 133.894C163.387 133.894 174.515 152.625 176.766 155.258C179.017 157.849 183.986 162.606 186.832 163.03C189.635 163.497 193.797 159.42 193.967 157.721C194.137 156.107 193.925 151.053 193.925 151.053Z"
          fill="#EEAF7C"
        />
        <path
          d="M161.645 119.962L152.343 120.684"
          stroke="#D1905E"
          strokeWidth="0.372909"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M159.606 123.403L149.498 123.19"
          stroke="#D1905E"
          strokeWidth="0.372909"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M157.311 127.013L148.52 126.121"
          stroke="#D1905E"
          strokeWidth="0.372909"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M110.381 128.032L127.583 159.377"
          stroke="#FFAB00"
          strokeWidth="1.17827"
          strokeMiterlimit="10"
        />
        <path
          d="M85.4896 129.773C85.4896 129.773 93.8992 129.646 94.4938 130.707C94.9185 131.472 94.3663 132.237 94.3663 132.237C94.3663 132.237 97.4244 132.789 95.8104 134.445C95.8104 134.445 98.4862 134.7 97.5943 136.144C97.5943 136.144 99.1657 136.908 98.1464 137.928C97.1271 138.947 92.3277 139.075 91.7331 138.82C91.1384 138.565 90.7137 137.843 90.7137 137.163C90.7137 137.163 89.4395 136.569 89.3971 135.252C89.3971 135.252 87.6132 134.36 87.7831 132.874C87.7406 132.874 84.3428 131.387 85.4896 129.773Z"
          fill="#EEAF7C"
        />
        <path
          d="M94.3674 132.236L87.7417 132.873"
          stroke="#D1905E"
          strokeWidth="0.372909"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M95.8132 134.445L89.3574 135.294"
          stroke="#D1905E"
          strokeWidth="0.372909"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M97.5955 136.144L90.6724 137.163"
          stroke="#D1905E"
          strokeWidth="0.372909"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M165.297 85.4753C165.297 85.4753 162.367 85.985 160.498 88.7033C160.498 88.7033 162.579 88.6183 163.471 88.7033L162.537 87.7689L165.297 85.4753Z"
          fill="#D1905E"
        />
        <path
          d="M224.545 240.954C224.545 240.954 225.699 248.43 228.678 254.629C231.656 260.829 245.21 291.583 245.21 291.583L258.581 287.511C258.581 287.511 256.028 275.537 254.934 269.581C253.84 263.624 247.762 254.629 247.033 251.286C246.304 247.943 246.608 240.103 246.608 240.103L224.545 240.954Z"
          fill="#EEAF7C"
        />
        <path
          d="M210.566 236.699C210.566 236.699 209.472 244.175 210.566 250.982C211.66 257.79 215.611 291.158 215.611 291.158H229.59C229.59 291.158 230.623 279.002 231.292 272.984C231.96 266.967 228.8 256.635 229.043 253.17C229.347 249.767 231.9 242.352 231.9 242.352L210.566 236.699Z"
          fill="#EEAF7C"
        />
        <path
          d="M229.286 255.845C229.286 255.845 226.064 248.49 225.456 245.877L223.208 245.634C223.208 245.634 225.335 253.9 229.65 257.972L229.286 255.845Z"
          fill="#D1905E"
        />
        <path
          d="M210.079 243.689C210.079 243.689 213.787 248.065 224.91 248.43C224.91 248.43 234.27 251.712 246.79 249.463V244.175L210.566 236.699C210.566 236.699 210.019 240.103 210.079 243.689Z"
          fill="#D1905E"
        />
        <path
          d="M261.439 161.394C261.439 161.394 265.694 172.456 267.213 181.998C268.733 191.601 270.07 203.392 271.711 209.166C273.352 214.94 274.932 237.246 276.816 238.948C278.761 240.589 269.219 242.048 264.296 242.048C259.373 242.048 258.461 248.551 248.311 248.004C238.161 247.457 218.59 247.518 216.219 244.479C213.849 241.379 210.445 240.468 206.677 240.103C202.909 239.738 198.046 237.854 194.096 236.821C190.145 235.727 195.19 233.539 197.56 222.173C199.93 210.807 201.207 182.667 211.235 162.184L261.439 161.394Z"
          fill="#F76E88"
        />
        <path
          d="M251.773 103.471C251.773 103.471 257.729 104.14 259.674 107.847C261.619 111.616 263.564 120.003 263.382 126.689C263.139 133.435 257.912 151.183 260.404 158.173C261.984 162.67 262.774 164.919 262.774 164.919C262.774 164.919 241.258 175.677 210.261 164.19L211.963 160.118C211.963 160.118 206.979 157.929 204.122 157.261C201.265 156.592 200.658 156.288 200.658 156.288C200.658 156.288 198.652 154.647 199.321 149.967L206.675 140.182C206.675 140.182 208.681 140.182 209.41 140.486C210.139 140.79 210.686 139.392 211.537 139.756C212.327 140.121 212.692 137.568 212.692 137.568C212.692 137.568 214.576 119.639 218.284 115.141C221.991 110.643 226.671 109.306 226.671 109.306L251.773 103.471Z"
          fill="#D4F197"
        />
        <path
          d="M225.639 103.471C225.639 103.471 226.125 107.482 225.639 109.67C225.153 111.859 220.838 113.803 224.241 113.621C227.645 113.439 238.403 109.184 243.873 106.631C249.343 104.079 251.774 103.41 251.774 103.41C251.774 103.41 245.149 100.736 244.663 98.3047C244.177 95.8735 243.569 88.2761 243.569 88.2761L229.651 94.1717L225.639 103.471Z"
          fill="#EEAF7C"
        />
        <path
          d="M244.238 90.0996V95.3874L244.663 98.4264C244.663 98.4264 239.619 109.245 225.761 108.577L225.7 104.687L244.238 90.0996Z"
          fill="#D1905E"
        />
        <path
          d="M212.755 66.2742C212.755 66.2742 211.296 68.8269 211.174 71.7443C211.053 74.6009 211.539 80.8004 211.964 81.9552C212.39 83.11 213.119 85.4804 213.058 86.3921C212.998 87.3038 211.843 93.4425 214.456 97.0285C217.131 100.614 219.623 104.808 222.358 104.93C225.093 105.051 231.11 105.477 235.304 102.012C239.497 98.548 244.664 92.5916 244.603 82.6238C244.542 72.656 232.812 64.7547 228.496 64.3292C224.181 63.9038 215.915 60.804 212.755 66.2742Z"
          fill="#EEAF7C"
        />
        <path
          d="M230.198 137.264C230.198 137.264 232.629 137.204 233.845 137.811C235.06 138.419 236.823 138.298 237.734 138.602C238.646 138.966 239.801 139.452 241.685 139.635C243.569 139.756 245.028 139.088 247.459 140.121C249.89 141.154 251.896 142.795 251.896 142.795C251.896 142.795 249.222 139.027 247.338 138.115C245.453 137.204 242.658 138.176 242.658 138.176C242.658 138.176 241.381 133.131 242.111 131.977C242.901 130.761 243.995 124.926 244.177 123.771C244.299 122.617 245.393 115.141 248.249 111.737C248.249 111.737 245.271 113.56 243.995 118.605C242.718 123.65 242.597 127.236 241.928 128.573C241.26 129.91 239.558 134.955 240.773 137.568C240.773 137.568 238.038 138.237 236.337 137.447C234.695 136.535 230.198 137.264 230.198 137.264Z"
          fill="#BDE26C"
        />
        <path
          d="M229.894 156.835C229.894 156.835 234.938 157.078 238.707 158.233C242.414 159.388 249.769 162.731 253.172 160.482C256.576 158.233 258.642 155.498 259.797 151.244C259.797 151.244 258.46 159.267 255.421 160.847C252.321 162.366 249.951 163.643 246.79 162.123C243.63 160.664 237.248 159.57 234.938 158.598C232.629 157.625 229.894 156.835 229.894 156.835Z"
          fill="#BDE26C"
        />
        <path
          d="M230.196 152.216C230.196 152.216 230.196 155.863 229.832 156.775C229.467 157.747 227.765 150.879 227.765 150.879L230.196 152.216Z"
          fill="#BDE26C"
        />
        <path
          d="M211.902 160.239C211.902 160.239 213.908 151.669 213.3 148.022C212.693 144.376 212.693 138.48 212.693 138.48C212.693 138.48 212.206 143.768 212.267 146.442C212.328 149.116 211.902 160.239 211.902 160.239Z"
          fill="#BDE26C"
        />
        <path
          d="M200.66 156.41C200.66 156.41 202.726 155.802 204.367 154.83L199.565 149.846C199.505 149.785 198.289 154.647 200.66 156.41Z"
          fill="#BDE26C"
        />
        <path
          d="M230.197 137.264L222.904 134.712C222.904 134.712 221.506 132.341 221.445 131.612C221.384 130.943 220.837 125.412 221.02 123.407C221.202 121.401 221.02 117.937 220.108 116.843C219.196 115.748 217.008 114.715 216.218 114.594C215.428 114.472 213.118 113.864 212.45 114.472C212.024 114.837 211.66 115.688 212.146 115.992C212.146 115.992 208.803 116.478 211.538 119.031C211.538 119.031 207.891 119.456 207.709 121.705C207.587 122.981 207.587 123.589 209.836 124.926C209.836 124.926 207.648 127.661 209.411 127.965C210.687 128.208 211.295 127.904 211.295 127.904C211.295 127.904 211.113 137.447 213.24 139.635C215.367 141.762 226.55 151.365 230.319 152.216C230.197 152.216 231.899 143.707 230.197 137.264Z"
          fill="#EEAF7C"
        />
        <path
          d="M212.147 116.052C212.147 116.052 216.158 116.356 216.705 116.417C217.252 116.478 220.656 118.119 220.656 118.119"
          stroke="#D1905E"
          strokeWidth="0.607793"
          strokeMiterlimit="10"
        />
        <path
          d="M211.538 119.092H214.577C214.577 119.092 217.86 120.55 218.224 121.28C218.589 122.009 219.318 125.048 219.318 125.048"
          stroke="#D1905E"
          strokeWidth="0.607793"
          strokeMiterlimit="10"
        />
        <path
          d="M209.775 124.926C209.775 124.926 212.267 123.832 213.057 124.014C213.848 124.258 217.373 127.661 217.373 127.661C217.373 127.661 215.245 123.711 214.151 123.103C213.057 122.495 211.052 122.981 209.411 122.981C207.77 122.981 207.648 121.705 207.648 121.705"
          stroke="#D1905E"
          strokeWidth="0.607793"
          strokeMiterlimit="10"
        />
        <path
          d="M211.234 127.904C211.234 127.904 212.511 127.843 212.572 127.904C212.632 127.965 213.605 130.153 213.666 131.429C213.726 132.706 212.389 133.678 212.815 135.441"
          stroke="#D1905E"
          strokeWidth="0.607793"
          strokeMiterlimit="10"
        />
        <path
          d="M206.676 140.303L202.239 136.596C202.239 136.596 202.421 134.043 201.267 132.888C200.112 131.733 198.167 131.247 197.559 131.004C196.951 130.761 191.238 127.722 189.779 127.479C188.321 127.236 186.923 128.208 186.74 128.877C186.558 129.545 187.47 131.429 187.47 131.429C187.47 131.429 186.315 132.949 186.74 134.651C186.74 134.651 185.403 135.319 185.829 137.204C185.829 137.204 184.005 138.541 185.768 140.729C187.531 142.917 190.813 141.823 190.813 141.823C190.813 141.823 193.001 144.558 195.189 144.862L204.366 154.83C204.306 154.83 211.66 145.53 206.676 140.303Z"
          fill="#EEAF7C"
        />
        <path
          d="M192.396 122.988L196.099 122.759L197.626 147.483L193.923 147.712L192.396 122.988Z"
          fill="#F76E88"
        />
        <path
          d="M194.038 119.451C193.547 119.481 193.09 119.738 192.768 120.164C192.446 120.591 192.285 121.152 192.32 121.725L192.398 122.989L196.101 122.76L196.023 121.496C195.988 120.923 195.759 120.386 195.386 120.003C195.014 119.619 194.529 119.421 194.038 119.451Z"
          fill="#6464DC"
        />
        <path
          d="M192.396 122.988L196.099 122.759L196.146 123.52L192.443 123.748L192.396 122.988Z"
          fill="white"
        />
        <path
          d="M197.628 147.483L195.797 150.651L193.926 147.712L197.628 147.483Z"
          fill="#FFDF99"
        />
        <path
          d="M195.231 149.733L196.711 149.068L195.795 150.652L195.231 149.733Z"
          fill="#282796"
        />
        <path
          d="M197.559 131.004C197.559 131.004 195.249 132.767 194.824 133.8C194.277 135.076 194.277 137.021 196.222 136.474C198.227 135.927 197.863 135.623 199.443 135.502"
          fill="#EEAF7C"
        />
        <path
          d="M197.559 131.004C197.559 131.004 195.249 132.767 194.824 133.8C194.277 135.076 194.277 137.021 196.222 136.474C198.227 135.927 197.863 135.623 199.443 135.502"
          stroke="#D1905E"
          strokeWidth="0.607793"
          strokeMiterlimit="10"
        />
        <path
          d="M189.9 127.54L190.63 130.275C190.63 130.275 192.635 131.551 192.757 132.584C192.879 133.617 192.939 134.529 192.028 134.468C191.116 134.408 187.469 131.308 187.469 131.308"
          fill="#EEAF7C"
        />
        <path
          d="M189.9 127.54L190.63 130.275C190.63 130.275 192.635 131.551 192.757 132.584C192.879 133.617 192.939 134.529 192.028 134.468C191.116 134.408 187.469 131.308 187.469 131.308"
          stroke="#D1905E"
          strokeWidth="0.607793"
          strokeMiterlimit="10"
        />
        <path
          d="M192.149 134.529C192.149 134.529 195.735 136.231 195.796 137.507C195.857 138.784 195.614 139.452 194.885 139.452C194.885 139.452 197.437 142.37 194.094 142.066L190.995 141.093C190.995 141.093 191.359 141.64 190.812 141.762"
          fill="#EEAF7C"
        />
        <path
          d="M192.149 134.529C192.149 134.529 195.735 136.231 195.796 137.507C195.857 138.784 195.614 139.452 194.885 139.452C194.885 139.452 197.437 142.37 194.094 142.066L190.995 141.093C190.995 141.093 191.359 141.64 190.812 141.762"
          stroke="#D1905E"
          strokeWidth="0.607793"
          strokeMiterlimit="10"
        />
        <path
          d="M186.74 134.59C186.74 134.59 187.774 136.413 189.232 137.143C190.63 137.872 194.885 139.452 194.885 139.452"
          stroke="#D1905E"
          strokeWidth="0.607793"
          strokeMiterlimit="10"
        />
        <path
          d="M185.828 137.143C185.828 137.143 186.679 138.966 187.834 139.452C188.989 139.939 190.994 141.093 190.994 141.093"
          stroke="#D1905E"
          strokeWidth="0.607793"
          strokeMiterlimit="10"
        />
        <path
          d="M214.881 59.5275C214.881 59.5275 208.317 61.5332 207.831 67.6111C207.344 73.6891 211.174 76.2418 211.174 76.2418C211.174 76.2418 212.268 72.8989 212.936 71.4402C213.605 69.9815 214.152 67.8542 214.152 67.8542C214.152 67.8542 215.55 72.1696 217.798 73.5067C220.047 74.8439 221.141 74.9047 221.141 74.9047C221.141 74.9047 219.683 73.4459 219.987 70.954C220.29 68.462 220.29 68.462 220.29 68.462C220.29 68.462 220.777 70.8324 224.727 73.8106C228.678 76.7888 241.989 79.8278 242.657 81.2865C242.657 81.2865 242.961 94.5972 244.237 95.3873C245.514 96.1774 255.239 87.6683 254.995 79.22C254.752 70.8324 254.874 58.4335 243.387 53.7535C233.54 49.6812 223.451 49.742 214.881 59.5275Z"
          fill="#483000"
        />
        <path
          d="M212.511 60.6216C212.511 60.6216 214.395 57.7649 217.069 57.2179C217.069 57.2179 237.248 53.6319 247.58 78.5515L244.541 79.5239C244.602 79.5239 234.026 58.6158 212.511 60.6216Z"
          fill="#D75674"
        />
        <path
          d="M244.603 50.7754C244.603 50.7754 245.15 47.5541 249.101 47.0679C253.051 46.5817 259.433 48.7697 260.952 51.6263C262.411 54.483 264.964 66.5173 265.389 71.6835C265.876 76.8498 265.936 88.4586 265.572 92.2269C265.207 95.9952 260.223 98.7911 256.637 99.8243C256.637 99.8243 257.306 98.2441 259.494 93.4425C260.527 91.1937 259.858 88.3371 259.858 88.3371C259.858 88.3371 261.256 89.0664 259.251 91.923C257.245 94.7797 253.72 94.962 253.72 94.962C253.72 94.962 254.51 94.2934 254.935 89.9173C255.422 84.4472 255.665 79.3417 253.72 74.4186C251.775 69.4955 244.603 50.7754 244.603 50.7754Z"
          fill="#483000"
        />
        <path
          d="M242.657 81.2259C242.657 81.2259 245.575 77.9438 247.641 78.5516C249.708 79.1594 250.741 81.5906 250.741 82.9885C250.741 84.3865 250.072 87.4254 248.492 88.7626C246.851 90.1605 244.541 93.0779 242.353 91.9839C240.105 90.8898 242.657 81.2259 242.657 81.2259Z"
          fill="#EEAF7C"
        />
        <path
          d="M247.521 82.3806C247.521 82.3806 244.299 84.5079 243.448 87.9115L246.487 87.1214L245.272 86.392L247.521 82.3806Z"
          fill="#D1905E"
        />
        <path
          d="M241.077 52.8419C241.077 52.8419 240.773 50.7147 244.542 50.7754C248.31 50.8362 253.233 55.1515 253.719 58.7983C254.205 62.4451 252.139 61.8373 252.139 61.8373L241.077 52.8419Z"
          fill="#D75674"
        />
        <path
          d="M261.377 242.96C261.377 242.96 261.924 226.185 260.404 221.261C258.885 216.338 258.581 185.341 258.581 185.341C258.581 185.341 259.493 212.631 261.499 216.217C263.504 219.742 262.532 242.413 262.532 242.413L261.377 242.96Z"
          fill="#013E4E"
        />
        <path
          d="M214.821 242.96C214.821 242.96 214.335 225.941 214.821 218.283C215.307 210.625 217.313 185.341 217.313 185.341C217.313 185.341 212.572 214.029 212.633 217.068C212.633 220.107 212.086 241.319 212.086 241.319L214.821 242.96Z"
          fill="#013E4E"
        />
        <path
          opacity="0.7"
          d="M196.039 133.375C196.039 133.375 197.073 133.922 197.498 135.076C197.498 135.076 195.979 136.413 195.432 135.563C194.885 134.712 196.039 133.375 196.039 133.375Z"
          fill="#EEAF7C"
        />
        <path
          opacity="0.7"
          d="M190.508 133.131C190.508 133.131 190.873 132.159 191.359 131.673C191.359 131.673 192.514 132.706 192.392 133.557C192.149 134.347 191.298 133.861 190.508 133.131Z"
          fill="#EEAF7C"
        />
        <path
          opacity="0.7"
          d="M193.061 138.298C193.061 138.298 193.304 137.021 193.851 136.535C193.851 136.535 195.005 136.9 195.127 137.69C195.309 138.48 194.823 138.966 194.58 138.906C194.398 138.845 193.061 138.298 193.061 138.298Z"
          fill="#EEAF7C"
        />
        <path
          opacity="0.7"
          d="M192.94 141.276C192.94 141.276 193.244 140.243 193.608 139.452C193.608 139.452 194.824 139.635 195.067 140.546C195.31 141.397 194.459 142.005 192.94 141.276Z"
          fill="#EEAF7C"
        />
        <path
          opacity="0.7"
          d="M188.867 141.762C188.867 141.762 188.989 141.033 189.353 140.668C189.353 140.668 190.326 140.85 190.447 141.215C190.508 141.58 189.718 142.066 188.867 141.762Z"
          fill="#EEAF7C"
        />
        <path
          opacity="0.7"
          d="M214.456 114.351L213.97 115.445C213.97 115.445 212.39 115.566 212.39 114.898C212.451 114.229 213.241 114.168 214.456 114.351Z"
          fill="#EEAF7C"
        />
        <path
          opacity="0.7"
          d="M213.059 116.478C213.059 116.478 212.512 117.39 212.512 118.119C212.512 118.119 210.871 118.301 210.749 117.146C210.567 116.052 213.059 116.478 213.059 116.478Z"
          fill="#EEAF7C"
        />
        <path
          opacity="0.7"
          d="M210.627 119.76C210.627 119.76 210.202 120.854 210.202 121.887C210.202 121.887 207.771 122.313 207.832 121.036C207.892 119.882 210.627 119.76 210.627 119.76Z"
          fill="#EEAF7C"
        />
        <path
          opacity="0.7"
          d="M210.627 125.291C210.627 125.291 210.566 126.385 210.809 127.114C210.809 127.114 208.986 128.208 208.682 127.357C208.378 126.506 209.593 125.412 210.627 125.291Z"
          fill="#EEAF7C"
        />
      </g>
      <defs>
        <clipPath id="clip0_8331_202282">
          <rect width="292" height="291" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

IndividualsAndGroupsIllustration.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  style: PropTypes.object,
  fill: PropTypes.string,
};

IndividualsAndGroupsIllustration.defaultProps = {
  width: 292,
  height: 292,
  fill: "none",
  style: {},
};

export default IndividualsAndGroupsIllustration;
